import { HttpCacheManager, withCache } from '@ngneat/cashew';
import { Observable } from 'rxjs';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { environment } from '@environments/environment';

import { API } from '@models/API/index';
import { Notification } from '@models/notification.model';

import { platformAPI } from '@services/API/endpoints';

@Injectable({ providedIn: 'root' })
export class NotificationAPI {
  private http = inject(HttpClient);
  private cacheManager = inject(HttpCacheManager);

  private cacheKey = 'notifications';

  getAll(
    loaderOptIn: boolean | string = true
  ): Observable<API.Notify.Notification.Response> {
    return this.http.get<API.Notify.Notification.Response>(
      platformAPI.notify.notifications,
      {
        headers: new HttpHeaders({
          'Loader-Opt-In': `${loaderOptIn}`,
          'Auth-Opt-In': 'true',
        }),
        context: withCache({
          ttl: environment.NOTIFICATIONS_CACHE_LIFETIME!,
          key: this.cacheKey,
        }),
      }
    );
  }

  markAsViewed(id: string, loaderOptIn: boolean | string = true) {
    this.cacheManager.delete(this.cacheKey);

    const status: Notification.Status = 'VIEWED';

    return this.http.patch(
      platformAPI.notify.notifications + `/${id}`,
      {
        status: status,
      },
      {
        headers: new HttpHeaders({
          'Loader-Opt-In': `${loaderOptIn}`,
          'Auth-Opt-In': 'true',
        }),
      }
    );
  }

  getCount(loaderOptIn: boolean | string = true) {
    return this.http.get<API.Notify.Notification.UnreadCount.Response>(
      platformAPI.notify.unreadCount,
      {
        headers: new HttpHeaders({
          'Loader-Opt-In': `${loaderOptIn}`,
          'Auth-Opt-In': 'true',
        }),
      }
    );
  }
}
